import Chart from "chart.js/auto";
import initSidebarScrollSpy from './l-sidebar';
import { gsap, ScrollTrigger } from '../foundation/animation.js';

document.addEventListener("DOMContentLoaded", () => {
  initSidebarScrollSpy();

  const canvas = document.getElementById('threejs-canvas');
  const triggerSection = document.getElementById('about_us');

  if (canvas && triggerSection) {
    gsap.to(canvas, {
      opacity: 0,
      ease: "none",
      scrollTrigger: {
        trigger: triggerSection,
        start: "top center",
        end: "center center",
        toggleActions: "play none none reverse",
      }
    });
  }

  const ageChartCtx = document.getElementById("ageChart");
  if (ageChartCtx) {
    new Chart(ageChartCtx, {
      type: "doughnut",
      data: {
        labels: ["20代", "30代", "40代", "50代"],
        datasets: [
          {
            label: "年齢層",
            data: [21, 33, 34, 12],
            backgroundColor: [
              "#FBC429",
              "#F5A20E",
              "#FFE9AA",
              "#FFF",
            ],
            hoverOffset: 4,
            borderWidth: 1,
            borderColor: "#E1E1E1"
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "right",
          },
        },
      },
    });
  }

  const genderChartCtx = document.getElementById("genderChart");
  if (genderChartCtx) {
    new Chart(genderChartCtx, {
      type: "doughnut",
      data: {
        labels: ["男性", "女性"],
        datasets: [
          {
            label: "男女比",
            data: [80, 20],
            backgroundColor: ["#F5A20E", "#FBC429"],
            hoverOffset: 4,
            borderWidth: 1,
            borderColor: "#E1E1E1"
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "right",
          },
        },
      },
    });
  }

  const commuteChartCtx = document.getElementById("commuteChart");
  if (commuteChartCtx) {
    new Chart(commuteChartCtx, {
      type: "doughnut",
      data: {
        labels: ["週に1回以上", "2週に1回", "月に1回", "2ヶ月に1回"],
        datasets: [
          {
            label: "出社頻度",
            data: [5, 11, 36, 21],
            backgroundColor: [
            "#FBC429",
            "#F5A20E",
            "#FFE9AA",
            "#FFF",
            ],
            hoverOffset: 4,
            borderWidth: 1,
            borderColor: "#E1E1E1"
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "right",
          },
        },
      },
    });
  }
});
